import { render, staticRenderFns } from "./UserCau.vue?vue&type=template&id=20fe410e&"
import script from "./UserCau.vue?vue&type=script&lang=js&"
export * from "./UserCau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports